<template>
  <div class="container">
    <div class="columns">
      <div class="col-8 col-md-12">
        <calendar />
      </div>
      <div class="col-4 col-md-12">
        <notifications />
      </div>
    </div>
  </div>
</template>

<script>
import calendar from '@/components/adminHome/calendar'
import notifications from '@/components/adminHome/notifications'

export default {
  name: 'adminHome',
  components: {
    calendar,
    notifications
  },
  created () {
    this.$root.$data.pageTitle = ''
  }
}
</script>



// WEBPACK FOOTER //
// adminHome.vue?194fb92a